import { Controller } from 'react-hook-form';
import { Col, FormFeedback, FormGroup, Label } from 'reactstrap';

import classNames from 'classnames';
import { get } from 'radash';

import { RadioButtonGroup } from '@hsp/react-component-library';

import { AudienceOrderType } from 'types/api/audience';
import { s } from 'utilities/strings';

import { useOrderTypeConfiguration } from './hooks';

import cssClasses from './order-type.module.scss';

const EditShop = () => {
  const { control, disabled } = useOrderTypeConfiguration();

  return (
    <FormGroup row>
      <Label sm={4}>{s(['Site.Order', 'Site.Type'])}</Label>
      <Col sm={8}>
        <Controller
          control={control}
          name="orderTypeId"
          render={({ field: { onChange, value }, formState: { errors } }) => {
            const isInvalid = get(errors, 'orderTypeId.type') === 'custom';

            return (
              <>
                <RadioButtonGroup
                  className={classNames({
                    'is-invalid': isInvalid,
                    [cssClasses.isInvalid]: isInvalid,
                  })}
                  name="order-type"
                  onChange={onChange}
                  orientation="vertical"
                  value={value}>
                  <RadioButtonGroup.Item
                    disabled={disabled}
                    label={s('Site.House')}
                    value={AudienceOrderType.House}
                  />
                  <RadioButtonGroup.Item
                    disabled={disabled}
                    label={s('Site.OnPoint')}
                    value={AudienceOrderType.OnPoint}
                  />
                  <RadioButtonGroup.Item
                    disabled={disabled}
                    label={s('Site.Custom')}
                    value={AudienceOrderType.Custom}
                  />
                </RadioButtonGroup>
                <FormFeedback type="invalid">{get(errors, 'orderTypeId.message')}</FormFeedback>
              </>
            );
          }}
        />
      </Col>
    </FormGroup>
  );
};

export default EditShop;
